import { render, staticRenderFns } from "./EditProductModal.vue?vue&type=template&id=4d51e962&scoped=true&"
import script from "./EditProductModal.vue?vue&type=script&lang=js&"
export * from "./EditProductModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProductModal.vue?vue&type=style&index=0&id=4d51e962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51e962",
  null
  
)

export default component.exports